import React from 'react';
import type LiveChatMyChatsType from '@atlassian/jira-spa-apps-servicedesk-live-chat-my-chats/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyLiveChatMyChats = lazyForPaint<typeof LiveChatMyChatsType>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-live-chat-my-chats", jiraSpaEntry: "async-servicedesk-live-chat-my-chats" */ '@atlassian/jira-spa-apps-servicedesk-live-chat-my-chats'
		),
);

const AsyncLiveChatMyChats = (): React.JSX.Element => (
	<LazyPage
		Page={LazyLiveChatMyChats}
		pageId="spa-apps/servicedesk/live-chat/my-chats"
		shouldShowSpinner
	/>
);

export default AsyncLiveChatMyChats;
